// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"IO","innerWrapper":"JO","tooltipWrapper":"KO","icon":"LO","tooltip":"MO","content":"NO"};